export const AchievementType = {
  1: 'Session',
  2: 'Week',
  3: 'Program',
  4: 'Forum',
  5: 'Profile',
  6: 'WorkoutRating',
  7: 'PrepSession',
};

export const TriggerType = {
  1: 'Coded',
  2: 'Times',
};

const buildChoices = (mapping) =>
  Object.entries(mapping).map(([value, name]) => ({
    id: Number(value),
    name,
  }));

export const typeChoices = buildChoices(AchievementType);
export const triggerTypeChoices = buildChoices(TriggerType);

export const thresholdFriendlyTypes = [
  AchievementType.Session,
  AchievementType.Week,
  AchievementType.PrepSession,
];

export const PROTECTED_ACHIEVEMENT_NAMES = [
  'AP Member',
  'Training Logged',
  'Member',
  'Profile Completed',
];

const recommendedTimesCopy = {
  [AchievementType.Session]: 'Popular milestones: 1, 5, 10, 25, 50, 100, 200 sessions.',
  [AchievementType.Week]: 'Popular milestones: 1, 2, 3, 5, 10, 20 weeks.',
  [AchievementType.PrepSession]: 'Try 1, 5, 10 prep sessions to start.',
};

export const getRecommendedTimesCopy = (type) => recommendedTimesCopy[type] || null;

const protectedNamesLookup = new Set(
  PROTECTED_ACHIEVEMENT_NAMES.map((name) => name.trim().toLowerCase()),
);

export const isProtectedAchievementName = (name) =>
  Boolean(name) && protectedNamesLookup.has(name.trim().toLowerCase());
